export default "__VITE_ASSET__CO0BS4Ok__"